import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { fetchMerchantAccountProductsPrices } from "actions/merchantAccount";
import { fetchIntegrations } from "actions/integration";
import Tabs from "components/Tabs";
import { WHITE_TAB_STYLES } from "components/Tabs";
import { PRODUCT_PRICES_TABS } from "utils/constants/product";
import startCase from "lodash/startCase";
import ProductsDashboardContainer from "./ProductsDashboardContainer";
import SectionHeader from "components/SectionHeader";
import classnames from "classnames";
import {
  ensureIntegrations,
  ensureProductsPrices,
  useScrollTopOnMount
} from "utils/hooks";
import { HUB_CLASSES } from "utils/constants/ui";

const DEFAULT_CONTENT = {
  header: "Products",
  subheader: "Manage all of your products and prices here."
};

const ProductPricesHub = ({ header, subheader, customClasses, actions }) => {
  useScrollTopOnMount();

  const classes = { ...HUB_CLASSES, ...customClasses };
  const { loading } = ensureProductsPrices({
    fetchMerchantAccountProductsPrices:
      actions.fetchMerchantAccountProductsPrices
  });
  ensureIntegrations({
    fetchIntegrations: actions.fetchIntegrations
  });
  const content = {
    ...DEFAULT_CONTENT
  };
  if (header) {
    content.header = header;
  }
  if (subheader) {
    content.subheader = subheader;
  }

  const tabProps = {
    minWidth: false,
    equalWidth: false,
    pathPrefix: "",
    customStyles: WHITE_TAB_STYLES,
    customClasses: {
      tabs: {
        list:
          "list ma0 pa0 nowrap center overflow-x-auto absolute top-0 left-0 right-0 ph3"
      }
    },
    tabs: [
      {
        name: startCase(PRODUCT_PRICES_TABS.PRICES),
        id: PRODUCT_PRICES_TABS.PRICES,
        node: <ProductsDashboardContainer loading={loading} />
      }
    ]
  };

  return (
    <div className={classes.container}>
      <div className="pt3">
        <SectionHeader header={content.header} subheader={content.subheader} />
        <div
          className={classnames("w-100", {
            "pt3 mt2": tabProps.tabs.length > 1
          })}
        >
          <Tabs {...tabProps} />
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      fetchMerchantAccountProductsPrices,
      fetchIntegrations
    },
    dispatch
  )
});

export default connect(null, mapDispatchToProps)(ProductPricesHub);
